import { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { useAtlas } from '../app/store.ts';
import { SHORTCUTS, type Shortcut } from '../app/shortcuts.ts';
import { IconButton, Kbd } from '../ui/primitives.tsx';

const GROUPS: Shortcut['group'][] = ['Scenes', 'View', 'Selection', 'Time'];

export function Help() {
  const open = useAtlas((s) => s.helpOpen);
  const setHelp = useAtlas((s) => s.setHelp);
  const sheet = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (open) sheet.current?.focus();
  }, [open]);
  if (!open) return null;
  return (
    <div className="sheet-overlay" onClick={() => setHelp(false)} role="presentation">
      <div ref={sheet} tabIndex={-1} className="sheet" role="dialog" aria-modal="true" aria-label="Keyboard shortcuts" data-label-exclude="" onClick={(e) => e.stopPropagation()}>
        <header className="sheet-head">
          <h2>Keyboard shortcuts</h2>
          <IconButton size="sm" icon={X} label="Close" keys={['Esc']} onClick={() => setHelp(false)} />
        </header>
        <div className="sheet-grid">
          {GROUPS.map((g) => (
            <section key={g}>
              <h3 className="caps">{g}</h3>
              <dl>
                {SHORTCUTS.filter((s) => s.group === g).map((s) => (
                  <div key={s.label + s.keys.join()} className="shortcut">
                    <dt>{s.label}</dt>
                    <dd>
                      {s.keys.map((k) => (k === '…' ? <span key={k} className="muted">–</span> : <Kbd key={k}>{k}</Kbd>))}
                    </dd>
                  </div>
                ))}
              </dl>
            </section>
          ))}
        </div>
        <p className="sheet-foot muted">Drag to orbit · right-drag or ⇧-drag to pan · scroll or pinch to zoom · double-click to focus</p>
      </div>
    </div>
  );
}
